import React from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import Home from './pages/Home';
import Hoerproben from './pages/Hoerproben';
import AktuelleProjekte from './pages/AktuelleProjekte';
import UeberMich from './pages/UeberMich';
import StimmenUeberMich from './pages/StimmenUeberMich';
import Kontakt from './pages/Kontakt';
import ImprintPrivacy from './pages/ImprintPrivacy';
import NotFound from './pages/NotFound';

const Routes = props => {
  const { data } = props;

  return (
    <Switch>
      <Route path="/" exact render={() => (
        <Redirect to="/home" />
      )} />

      <Route path="/home" render={props => (
        <Home {...props} data={ data.home } />
      )} />

      <Route path="/hoerproben" exact render={() => (
        <Hoerproben {...props} data={ data.hoerproben } />
      )} />

      <Route path="/aktuelle-projekte" exact render={() => (
        <AktuelleProjekte {...props} data={ data.aktuelleProjekte } />
      )} />

      <Route path="/ueber-mich" exact render={() => (
        <UeberMich {...props} data={ data.ueberMich } />
      )} />

      <Route path="/stimmen-ueber-mich" exact render={() => (
        <StimmenUeberMich {...props} data={ data.stimmenUeberMich } />
      )} />

      <Route path="/kontakt" exact render={props => (
        <Kontakt {...props} data={ data.kontakt } />
      )} />

      <Route path="/impressum-datenschutz" exact render={props => (
        <ImprintPrivacy {...props} data={ data.imprintPrivacy } />
      )} />

      <Route component={ NotFound } />
    </Switch>
  );
};

export default withRouter(Routes);